import React from 'react';
import AdminDashboard from '../pages/AdminDashboard';
import { ToastContainer } from 'react-toastify';
import { Route, Routes } from 'react-router';
import AdminLogin from '../pages/Login/Login';
import 'rc-select/assets/index.css';
function App() {
  return (
    <div className="App h-full">
      <Routes>
<Route element={<AdminLogin />} path="/" />
<Route element={<AdminDashboard />} path="/admin/*" />
      </Routes>
    
      <ToastContainer/>
    </div>
  );
}

export default App;
